<template>
    <!-- Product sales price weekly chart -->
    <v-hover>
        <template v-slot="{ hover }">
            <v-card :elevation="hover ? 6 : 3" :loading="isLoading">
                <slot name="header"></slot>
                <div class="pt-0">
                    <v-row align="center" class="mx-0">
                        <v-col cols="12">
                            <div id="chart">
                                <apexchart
                                    type="line"
                                    height="300"
                                    :options="chartOptions"
                                    :series="series"
                                ></apexchart>
                            </div>
                        </v-col>
                    </v-row>
                </div>

                <slot name="footer"></slot>
            </v-card>
        </template>
    </v-hover>
</template>

<script>
import gql from "graphql-tag";
import VueApexCharts from "vue-apexcharts";

export default {
    name: "product-sales-price-weekly-chart",
    components: { apexchart: VueApexCharts },
    data() {
        return {
            isLoading: false,

            series: [],
            chartOptions: {
                chart: {
                    id: "product-sales-price-weekly-chart",
                    type: "line",
                    height: 300,
                    zoom: {
                        enabled: false
                    },
                    toolbar: {
                        show: false
                    },
                    animations: {
                        enabled: false
                    }
                },
                stroke: {
                    width: [0, 1]
                },
                dataLabels: {
                    enabled: true,
                    enabledOnSeries: [1]
                },
                labels: [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10,
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20,
                    21,
                    22,
                    23,
                    24,
                    25,
                    26,
                    27,
                    28,
                    29,
                    30,
                    31,
                    32,
                    33,
                    34,
                    35,
                    36,
                    37,
                    38,
                    39,
                    40,
                    41,
                    42,
                    43,
                    44,
                    45,
                    46,
                    47,
                    48,
                    49,
                    50,
                    51,
                    52,
                    53
                ],
                xaxis: {
                    type: "numeric",
                    hideOverlappingLabels: true
                    // tickPlacement: 'on',
                    // categories: [
                    //     1,
                    //     2,
                    //     3,
                    //     4,
                    //     5,
                    //     6,
                    //     7,
                    //     8,
                    //     9,
                    //     10,
                    //     11,
                    //     12,
                    //     13,
                    //     14,
                    //     15,
                    //     16,
                    //     17,
                    //     18,
                    //     19,
                    //     20,
                    //     21,
                    //     22,
                    //     23,
                    //     24,
                    //     25,
                    //     26,
                    //     27,
                    //     28,
                    //     29,
                    //     30,
                    //     31,
                    //     32,
                    //     33,
                    //     34,
                    //     35,
                    //     36,
                    //     37,
                    //     38,
                    //     39,
                    //     40,
                    //     41,
                    //     42,
                    //     43,
                    //     44,
                    //     45,
                    //     46,
                    //     47,
                    //     48,
                    //     49,
                    //     50,
                    //     51,
                    //     52,
                    //     53
                    // ]
                },
                // yaxis: {
                //     labels: {
                //         formatter: function (val) {
                //             return val.toFixed(0);
                //         }
                //     },
                //     title: {
                //         text: "m2"
                //     },
                //     max: 2000 //default value, will be updated by greenhouse total space
                // },
                yaxis: [
                    {
                        title: {
                            text: "Volume"
                        },
                        labels: {
                            formatter: function(val) {
                                return val.toFixed(0);
                            }
                        }
                    },
                    {
                        opposite: true,
                        title: {
                            text: "Price"
                        },
                        labels: {
                            formatter: function(val) {
                                return `€ ${val.toFixed(2)}`;
                            }
                        }
                    }
                ],
                fill: {
                    opacity: 1
                },
                colors: ["#0362fc", "#FF4560"],
                legend: {
                    position: "top",
                    horizontalAlign: "left",
                    offsetX: 0,
                    offsetY: 0
                }
            }
        };
    },
    computed: {
        // hasPlantColors: function () {
        //     return this.plant.plantColorSet.edges.length > 0;
        // },
        // hasPlantEnvironments: function () {
        //     return this.plant.plantEnvironmentSet.edges.length > 0;
        // },
        // hasPlantPotSizes: function () {
        //     return this.plant.plantPotSizeSet.edges.length > 0;
        // },
        // hasPlantTags: function () {
        //     return this.plant.plantTagSet.edges.length > 0;
        // },
        // sortedPotSizes: function () {
        //     var _sorted = this.plant.plantPotSizeSet.edges;
        //     if (_sorted.length > 0) {
        //         _sorted = _sorted.sort((a, b) => {
        //             return a.node.potSize.potSizeCm - b.node.potSize.potSizeCm;
        //         });
        //     }
        //     return _sorted;
        // }
    },
    watch: {
        // greenhouseNodeId() {
        //     // console.log(val);
        //     this.getGreenhousePlannedSpace();
        // },
        // taskYear() {
        //     // console.log(val);
        //     this.getGreenhousePlannedSpace();
        // }
    },
    methods: {
        getProductSalesPriceByWeek(productNodeId) {
            // console.log(this.productNodeId);

            if (!productNodeId) {
                return;
            }

            this.isLoading = true;

            this.$apollo
                .query({
                    // Query
                    query: gql`
                        query product($id: ID!) {
                            product(id: $id) {
                                id
                                name
                                productSalesPriceByWeekSet(
                                    orderBy: "weekNumber"
                                ) {
                                    edges {
                                        node {
                                            id
                                            weekNumber
                                            avgSoldQuantity
                                            avgSalesPrice
                                        }
                                    }
                                }
                            }
                        }
                    `,
                    // Parameters
                    variables: {
                        id: productNodeId
                    },
                    fetchPolicy: "network-only"
                })
                .then(response => {
                    // Result
                    // console.log(response.data);

                    let _soldQuantityArray = [];
                    let _salesPriceArray = [];

                    this.chartOptions.labels.forEach(item => {
                        const a = response.data.product.productSalesPriceByWeekSet.edges.find(
                            e => {
                                return e.node.weekNumber == item;
                            }
                        );

                        _soldQuantityArray.push(
                            a ? a.node.avgSoldQuantity : null
                        );
                        _salesPriceArray.push(a ? a.node.avgSalesPrice : null);
                    });

                    // console.log(_soldQuantityArray);
                    // console.log(_salesPriceArray);

                    this.series = [
                        {
                            name: "Volume",
                            type: "column",
                            data: _soldQuantityArray
                        },
                        { name: "Price", type: "line", data: _salesPriceArray }
                    ];

                    // console.log(JSON.stringify(this.series));
                    // console.log(this.chartOptions);
                })
                .catch(error => {
                    // Error
                    console.error(error);
                })
                .finally(() => {
                    // this.isSavingOrderPrintStatus = false;
                    this.isLoading = false;
                });
        },

        clearChartSeriesData() {
            this.series = [];
        }
    }
};
</script>